import * as React from 'react';

import { Col, humanReadableDate, Row } from '@rematter/ui-web';
import { usePreferredLanguage } from '@uidotdev/usehooks';
import { useAtomValue } from 'jotai';

import { $organization } from '../../_state/organizationDetail.state';
import { useTranslations } from '../../i18n/useTranslations';

const DetailField: React.FC<{ label: string; value?: string | null }> = ({
  label,
  value,
}) => (
  <Col className="@DetailField">
    <span className="text-sm text-neutral/60">{label}</span>
    <span className="text-neutral/90">{value || '-'}</span>
  </Col>
);

//
// ⚛️ ⚛️ ⚛️ ORGANIZATION TAB DETAILS ⚛️ ⚛️ ⚛️
//
export const OrganizationTabDetails = () => {
  const t = useTranslations();

  const organization = useAtomValue($organization);

  const preferredLocale = usePreferredLanguage();

  return organization ? (
    <div className="@OrganizationTabDetails p-6">
      <Col gap4>
        <h3 className="text-lg font-semibold text-neutral/90">
          {t.organizationDetailView.sections.basicInfo}
        </h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <DetailField
            label={t.organizationDetailView.fields.name}
            value={organization.name}
          />
          <DetailField
            label={t.organizationDetailView.fields.domain}
            value={organization.domain}
          />
          <DetailField
            label={t.organizationDetailView.fields.timezone}
            value={organization.timezone}
          />
          <DetailField
            label={t.organizationDetailView.fields.idpId}
            value={organization.idpId}
          />
          <DetailField
            label={t.organizationDetailView.fields.createdAt}
            value={humanReadableDate(organization.createdAt, {
              locale: preferredLocale,
            })}
          />
          <DetailField
            label={t.organizationDetailView.fields.updatedAt}
            value={humanReadableDate(organization.updatedAt, {
              locale: preferredLocale,
            })}
          />
        </div>

        <h3 className="mt-4 text-lg font-semibold text-neutral/90">
          {t.organizationDetailView.sections.facilities}
        </h3>
        <Row gap2 className="flex-wrap">
          {organization.facilities.length === 0 && (
            <span className="text-sm text-neutral/50">
              {t.organizationDetailView.sections.noFacilities}
            </span>
          )}
          {organization.facilities.map((facility) => (
            <div
              key={facility.id}
              className="rounded-md border border-neutral/10 px-3 py-1.5 text-sm text-neutral/80"
            >
              {facility.facilityName}
            </div>
          ))}
        </Row>

        <h3 className="mt-4 text-lg font-semibold text-neutral/90">
          {t.organizationDetailView.sections.users}
        </h3>
        <Row gap2 className="flex-wrap">
          {organization.users.length === 0 && (
            <span className="text-sm text-neutral/50">
              {t.organizationDetailView.sections.noUsers}
            </span>
          )}
          {organization.users.map((user) => (
            <div
              key={user.id}
              className="rounded-md border border-neutral/10 px-3 py-1.5 text-sm text-neutral/80"
            >
              {user.firstName} {user.lastName}
            </div>
          ))}
        </Row>
      </Col>
    </div>
  ) : null;
};
